import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import OfflineBoltOutlinedIcon from '@material-ui/icons/OfflineBoltOutlined';
import WarningIcon from '@material-ui/icons/Warning';
import React from 'react';

const statusIconMap = {
    EFFECTIVE: {
        icon: CheckCircleIcon,
        className: 'num-positive',
        label: 'Effective'
    },
    EFFECTIVE_PENDING: {
        icon: WarningIcon,
        className: 'text-warning',
        label: 'Effective Pending'
    },
    EFFECTIVE_OFFLINE: {
        icon: OfflineBoltOutlinedIcon,
        className: 'text-muted',
        label: 'Effective Offline'
    },
    DELETE_PENDING: {
        icon: ErrorOutlineIcon,
        className: 'num-negative',
        label: 'Delete Pending'
    }
};

export const symbolMpidClearingColumnDefs = [
    {
        headerName: '',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 50,
        pinned: 'left',
        lockPosition: true,
        suppressMenu: true,
        sortable: false
    },
    {
        headerName: 'MPID',
        field: 'mpid',
        pinned: 'left',
        width: 120
    },
    {
        headerName: 'Symbol',
        field: 'symbol',
        width: 120
    },
    {
        headerName: 'Clearing Number',
        field: 'clearingNumber',
        width: 150
    },
    {
        headerName: 'Status',
        field: 'status',
        cellRendererFramework: ({data}) => {
            if (!data || !data.status) return null;

            const statusConfig = statusIconMap[data.status];
            if (!statusConfig) return <span>{data.status}</span>;

            const IconComponent = statusConfig.icon;

            return (
                <div className='flex-row flex-align-center flex-grow'>
                    <IconComponent className={statusConfig.className} />
                    &nbsp;{statusConfig.label}
                </div>
            );
        },
        width: 180
    },
    {
        headerName: 'Last Updated',
        field: 'lastUpdatedDate',
        valueFormatter: ({value}) => {
            if (!value) return '-';
            try {
                // Server sends UTC time without Z suffix, so append it for proper parsing
                const utcDateString = value.endsWith('Z') ? value : value + 'Z';
                return new Date(utcDateString).toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    timeZoneName: 'short'
                });
            } catch {
                return value;
            }
        },
        width: 200
    }
];
